<template>
	<div>
		<!-- 顶部 -->
		<div class="header-body">
			<Button type="primary" @click="add">添加</Button>
			<Form :label-width="80" inline>
				<FormItem label="姓名" class="search-item">
					<Input @keydown.enter.native.prevent="getList(1)" v-model="search.keywords" placeholder="请输入检索关键词" style="width: 200px;"></Input>
				</FormItem>
				<Button type="info" @click="getList(1)">搜索</Button>
				<Button type="default" @click="clearSearch" icon="md-refresh"></Button>
			</Form>
		</div>
		<Divider />
		<!-- table -->
		<Table :columns="columns" :data="data" border></Table>
		<!-- 分页 -->
		<div class="page-body">
			<Page :total="total" :current='page' @on-change="changePage" show-elevator show-total/>
		</div>
		
		<!-- 诗词 -->
		<Modal v-model="addShow" title="诗词信息" width="1300" :mask-closable="false">
			<Form ref="formData" :model="formData" :label-width="80">
				<Row>
					<Col span="12">
						<FormItem label="标题">
							<Input v-model="formData.title" placeholder="请输入诗人姓名" style="width: 200px;"></Input>
						</FormItem>
						<FormItem label="类型">
							<Input v-model="formData.type_text" placeholder="" style="width: 200px;"></Input>
						</FormItem>
						<FormItem label="朝代">
							<Input v-model="formData.dynasty" placeholder="请输入朝代" style="width: 200px;"></Input>
						</FormItem>
						<FormItem label="作者">
							<Input v-model="formData.author" placeholder="请输入作者" style="width: 200px;"></Input>
						</FormItem>
						<FormItem label="内容">
							<Input v-model="formData.content" type="textarea" :rows="5" placeholder="Enter something..." />
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem label="AI赏析">
							<Input v-model="formData.ai_desc" type="textarea" :rows="25" placeholder="Enter something..." />
						</FormItem>
					</Col>
				</Row>
			</Form>
			<div slot="footer">
				<Button type="default" @click="addShow = false;">取消</Button>
				<Button type="primary" @click="submit">提交</Button>
			</div>
		</Modal>
		
		<!-- 拼音 -->
		<Modal v-model="addPinyinShow" title="诗词拼音" width="1300" :mask-closable="false">
			<div class="pinyin-body">
				<div class="pinyin-item" v-for="(item,index) in formData.content_json" :key="index">
					<div class="pinyin-item-text" v-for="(itemc,indexc) in item" :key="indexc">
						<p>{{itemc.pinyin}}</p>
						<p>{{itemc.key}}</p>
					</div>
				</div>
			</div>
			<div slot="footer">
				<Button type="primary" @click="addPinyinShow = false;">确认</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import { getShici,getShiciDetail } from '@/utils/wenxue.js'
	export default {
		name: 'Shici',
		components: {
			
		},
		data() {
			return {
				search:{
					keywords:''
				},
				page:1,
				total:0,
				data: [],
				columns: [
					{
						title:'序号',
						width:80,
						align:'center',
						render:(h,param)=>{
							return h('span',{},param.index - 0 + 1)
						}
					},
					{
						title:'诗词标题',
						minWidth:120,
						align:'left',
						key:'title'
					},
					{
						title:'类型',
						width:120,
						align:'center',
						key:'type_text'
					},
					{
						title:'作者',
						width:120,
						align:'center',
						key:'author'
					},
					{
						title:'朝代',
						width:120,
						align:'center',
						key:'dynasty'
					},
					{
						title:'内容',
						minWidth:400,
						align:'left',
						key:'content'
					},
					{
						title:'拼音',
						width:100,
						align:'center',
						render:(h,param)=>{
							return h('i-switch',{
								props:{
									value:param.row.is_pinyin == 1 ? false : true,
									size:'large',
									disabled:true
								}
							},[
				              h('span', { slot: 'open' }, '已'),
				              h('span', { slot: 'close' }, '未'),
				            ])
						}
					},
					{
						title:'AI赏析',
						width:100,
						align:'center',
						render:(h,param)=>{
							return h('i-switch',{
								props:{
									value:param.row.is_ai_desc == 1 ? false : true,
									size:'large',
									disabled:true
								}
							},[
				              h('span', { slot: 'open' }, '已'),
				              h('span', { slot: 'close' }, '未'),
				            ])
						}
					},
					{
						title: '操作',
						minWidth: 150,
						align: 'center',
						render: (h, param) => {
							var _that = this;
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '6px'
									},
									on: {
										'click': function() {
											_that.formData.id = param.row.id;
											_that.getShiciDetail();
										}
									}
								}, '编辑'),
								h('Button', {
									props: {
										type: 'warning',
										size: 'small'
									},
									style: {
										marginRight: '6px'
									},
									on: {
										'click': function() {
											_that.formData.id = param.row.id;
											_that.getShiciPinyinDetail();
										}
									}
								}, '拼音'),
								h('Button', {
									props: {
										type: 'error',
										size: 'small'
									},
									style: {

									},
									on: {
										'click': function() {
											return false;
											_that.$Modal.confirm({
												title: '删除确认',
												content: '该操作不可逆，是否确认删除？',
												onOk: function() {
													deleteAuthor({
														id: param.row.id
													}).then(res => {
														let index = null;
														_that.data.forEach((e, key) => {
															if(e.id == res) {
																index = key;
															}
														})

														if(index !== null) _that.data.splice(index, 1);
													})
												}
											})
										}
									}
								}, '删除')
							])
						}
					}
				],
				addShow: false,
				addTitle:'添加诗人',
				formData: {},
				addPinyinShow:false,
			}
		},
		methods: {
			changePage(page){
				this.getList(page);
			},
			async getList(page) {
				this.page = page;
				const param = {
					page:page || 1,
					page_num:10,
					keywords:this.search.keywords
				};
				
				const data = await getShici({form:param});

				this.data = data['data'];
				this.total = data['total'];
			},
			add() {
				return false;
			},
			submit() {
				return false;
				var _that = this;
				this.$refs['formData'].validate((valid) => {
					if(valid) {
						const param = { ..._that.formData};
						
						if(param.id > 0) {
							editAuthor({
								form: param
							}).then((res) => {
								_that.$Message.info('编辑成功');
								_that.addShow = false;
								_that.getList(_that.page);
							})
						} else {
							addAuthor({
								form: param
							}).then((res) => {
								_that.$Message.info('添加成功');
								_that.addShow = false;
								_that.getList();
							})
						}
					}
				})
			},
			getShiciDetail(){
				getShiciDetail({id:this.formData.id || 0}).then((res)=>{
					this.addShow = true;
					this.formData = {...res};
				})
			},
			getShiciPinyinDetail(){
				getShiciDetail({id:this.formData.id || 0}).then((res)=>{
					this.addPinyinShow = true;
					this.formData = {...res};
				})
			},
			clearSearch(){
				this.search.keywords = '';
				this.getList();
			}
		},
		mounted() {
			this.getList();
		}
	}
</script>

<style scoped>
	.ivu-layout {
		height: 100vh !important;
	}
	
	.header-body {
		width: 100%;
		min-height: 36px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.ivu-divider-horizontal {
		margin: 12px !important;
	}
	.page-body{
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 12px;
	}
	.search-item{
		margin-bottom: 0px !important;
	}
	.pinyin-body{
		width: 90%;
		min-height: 400px;
		margin: 0 5%;
		display: flex;
		flex-wrap: wrap;
	}
	.pinyin-item{
		width: auto;
		height: 48px;
		margin: 4px 16px;
		display: flex;
	}
	.pinyin-item-text{
		margin: 0 4px;
		text-align: center;
	}
	.pinyin-item-text>p{
		width: auto;
		height: 24px;
	}
</style>


// WEBPACK FOOTER //
// src/views/wenxue/Shici.vue